import React from "react";

export default function LivingHarmonyHeader({ location }) {
  return (
    <header className="living-harmony-header bg-white text-[var(--lh-navy)]">
      <div className="max-w-screen-xl mx-auto flex items-center justify-between py-3 px-6">
        {/* Brand block: 2-row grid, logo spans both rows */}
        <div className="grid grid-cols-[auto_1fr] grid-rows-2 gap-x-3">
          <img
            src="/images/LivingHarmony.jpg"
            alt="Living Harmony logo"
            className="lh-logo row-span-2 self-center border-2 border-[var(--lh-blue)] rounded-xl p-0.5 object-contain"
          />
          <p className="text-sm md:text-base text-[var(--lh-blue)]/90 leading-tight">
            Your personal interior design AI
          </p>
        </div>

        {location && (
          <div className="text-sm md:text-base flex items-center gap-2">
            <span className="text-[var(--lh-blue)]" aria-hidden>
              📍
            </span>
            <span className="font-medium">{location}</span>
          </div>
        )}
      </div>

      <div className="h-1 w-full bg-[var(--lh-blue)]" />
    </header>
  );
}
